module.exports = __webpack_public_path__ + "static/media/resources.f0781dd8.png";